module.exports = __webpack_public_path__ + "img/Raspberries.a030ff5d.png";